module.exports = __webpack_public_path__ + "img/bg.a1ad9d73.jpg";